"use client";

import React from "react";
import Breadcrumb from "@/components/common/Breadcrumb";
import { User, Phone, Mail } from "lucide-react";

export default function SafetyPolicyPage() {
  return (
    <div className="w-full bg-[#f9f9f9] text-[#1e1e1e] font-sans pb-[100px] relative">
      <Breadcrumb
        title="Safety Policy"
        paths={[
          { label: "HOME", href: "/" },
          { label: "Safety Policy" },
        ]}
      />

      {/* Main Content Container */}
      <div className="relative z-10 w-full max-w-[1700px] mx-auto px-3 sm:px-6 lg:px-[50px] mt-10">
        <div className="w-full max-w-[1100px] mx-auto bg-white border border-[#eee] shadow-sm p-8 sm:p-12 lg:p-16">
          
          <div className="space-y-8">
            {/* Section 1 */}
            <section>
              <h4 className="text-[17px] sm:text-[19px] font-bold text-[#191919] mb-3 flex items-start gap-2">
                <span className="mt-[6px] w-0 h-0 border-t-[5px] border-t-transparent border-l-[6px] border-l-[#191919] border-b-[5px] border-b-transparent shrink-0"></span>
                <span>HEARTLAND LIMOUSINE SERVICES LLC<br /> ZERO-TOLERANCE POLICY FOR INTOXICATING SUBSTANCES</span>
              </h4>
              <p className="text-[15px] sm:text-[16px] text-[#555] mb-4">
                <strong>Effective Date:</strong> [02/02/2025] | <strong>Policy Number:</strong> HLS-ZT-2024
              </p>
            </section>

            {/* Section 2 */}
            <section>
              <h4 className="text-[17px] sm:text-[19px] font-bold text-[#191919] mb-3 flex items-start gap-2">
                <span className="mt-[6px] w-0 h-0 border-t-[5px] border-t-transparent border-l-[6px] border-l-[#191919] border-b-[5px] border-b-transparent shrink-0"></span>
                <span>ADA COMPLIANCE:</span>
              </h4>
              <p className="text-[15px] sm:text-[16px] text-[#555] mb-4">
                Heartland Limo Services is proud to offer wheelchair-accessible vehicles upon request. Please inform us when booking to ensure appropriate accommodations are made.
              </p>
            </section>

            {/* Section 3 */}
            <section>
              <h4 className="text-[17px] sm:text-[19px] font-bold text-[#191919] mb-3 flex items-start gap-2">
                <span className="mt-[6px] w-0 h-0 border-t-[5px] border-t-transparent border-l-[6px] border-l-[#191919] border-b-[5px] border-b-transparent shrink-0"></span>
                <span>Complaints to the City of Dallas (Ordinance 29696)</span>
              </h4>
              <p className="text-[15px] sm:text-[16px] text-[#555] mb-4">
                If you wish to file a complaint with the City of Dallas, please call 311.
              </p>
            </section>

            {/* Section 4 */}
            <section>
              <h4 className="text-[17px] sm:text-[19px] font-bold text-[#191919] mb-3 flex items-start gap-2">
                <span className="mt-[6px] w-0 h-0 border-t-[5px] border-t-transparent border-l-[6px] border-l-[#191919] border-b-[5px] border-b-transparent shrink-0"></span>
                <span>Operating Authority Contact Information:</span>
              </h4>
              <ul className="list-none space-y-1.5 text-[14px] text-[#555] pl-6">
                <li className="flex items-center">
                  <span className="w-1 h-1 bg-[#555] rounded-full mr-3 shrink-0"></span>
                  General Manager : Ebi S
                </li>
                <li className="flex items-center">
                  <span className="w-1 h-1 bg-[#555] rounded-full mr-3 shrink-0"></span>
                  Phone : (469) 525-3322
                </li>
                <li className="flex items-center">
                  <span className="w-1 h-1 bg-[#555] rounded-full mr-3 shrink-0"></span>
                  Email : info@hlselitecars.com
                </li>
              </ul>
            </section>

            {/* Section 5 */}
            <section>
              <h4 className="text-[17px] sm:text-[19px] font-bold text-[#191919] mb-3 flex items-start gap-2 mt-8">
                <span className="mt-[6px] w-0 h-0 border-t-[5px] border-t-transparent border-l-[6px] border-l-[#191919] border-b-[5px] border-b-transparent shrink-0"></span>
                <span>1. PURPOSE</span>
              </h4>
              <p className="text-[15px] sm:text-[16px] text-[#555] mb-4 leading-relaxed">
                Heartland Limousine Services LLC is committed to ensuring the highest level of safety for our passengers, employees, and the general public. This Zero-Tolerance Policy for intoxicating substances aligns with <strong>SEC.47A-2.1.6</strong>, enforcing strict prohibitions on alcohol, controlled substances, and impairing medications during work-related activities.
              </p>
            </section>

            {/* Section 6 */}
            <section>
              <h4 className="text-[17px] sm:text-[19px] font-bold text-[#191919] mb-3 flex items-start gap-2">
                <span className="mt-[6px] w-0 h-0 border-t-[5px] border-t-transparent border-l-[6px] border-l-[#191919] border-b-[5px] border-b-transparent shrink-0"></span>
                <span>2. SCOPE</span>
              </h4>
              <p className="text-[15px] sm:text-[16px] text-[#555] mb-3">
                This policy applies to all employees, independent contractors, and affiliates operating under Heartland Limousine Services LLC. It covers:
              </p>
              <ul className="list-none space-y-1.5 text-[14px] text-[#555] pl-6 mb-4">
                <li className="flex items-center">
                  <span className="w-1 h-1 bg-[#555] rounded-full mr-3 shrink-0"></span>
                  All commercial driving activities.
                </li>
                <li className="flex items-center">
                  <span className="w-1 h-1 bg-[#555] rounded-full mr-3 shrink-0"></span>
                  Any on-duty work within company premises.
                </li>
                <li className="flex items-center">
                  <span className="w-1 h-1 bg-[#555] rounded-full mr-3 shrink-0"></span>
                  Representing Heartland Limousine Services LLC in any professional capacity.
                </li>
              </ul>
            </section>

            {/* Section 7 */}
            <section>
              <h4 className="text-[17px] sm:text-[19px] font-bold text-[#191919] mb-3 flex items-start gap-2 mt-8">
                <span className="mt-[6px] w-0 h-0 border-t-[5px] border-t-transparent border-l-[6px] border-l-[#191919] border-b-[5px] border-b-transparent shrink-0"></span>
                <span>3. PROHIBITED CONDUCT</span>
              </h4>
              <p className="text-[15px] sm:text-[16px] text-[#555] mb-3">Under this policy, the following actions are strictly prohibited:</p>
              <p className="text-[15px] sm:text-[16px] text-[#555] mb-2">
                <strong>• Alcohol Consumption:</strong> No driver shall consume alcohol within 24 hours before or during a scheduled shift.
              </p>
              <p className="text-[15px] sm:text-[16px] text-[#555] mb-2">
                <strong>• Drug Use:</strong> Any use, possession, distribution, or influence of illegal drugs while on duty or operating company vehicles is strictly forbidden.
              </p>
              <p className="text-[15px] sm:text-[16px] text-[#555] mb-2">
                <strong>• Prescription and Over-the-counter Medications:</strong> Drivers must report any prescribed or over-the-counter medications that may impair their ability to operate a vehicle safely. Failure to disclose such use is a violation of this policy.
              </p>
              <p className="text-[15px] sm:text-[16px] text-[#555] mb-4">
                <strong>• Refusal of Testing:</strong> Any refusal to submit to drug and alcohol testing as required by law or company policy will result in immediate suspension and further disciplinary action.
              </p>
            </section>

            {/* Section 8 */}
            <section>
              <h4 className="text-[17px] sm:text-[19px] font-bold text-[#191919] mb-3 flex items-start gap-2 mt-8">
                <span className="mt-[6px] w-0 h-0 border-t-[5px] border-t-transparent border-l-[6px] border-l-[#191919] border-b-[5px] border-b-transparent shrink-0"></span>
                <span>4. TESTING AND ENFORCEMENT</span>
              </h4>
              <p className="text-[15px] sm:text-[16px] text-[#555] mb-3">
                Heartland Limousine Services LLC enforces this policy through the following measures:
              </p>
              <ul className="list-none space-y-1.5 text-[14px] text-[#555] pl-6 mb-4">
                <li className="flex items-start">
                  <span className="w-1 h-1 bg-[#555] rounded-full mt-[7px] mr-3 shrink-0"></span>
                  <span><strong>Pre-Employment Drug Screening</strong> – All prospective employees and contractors must pass a drug and alcohol test before being hired.</span>
                </li>
                <li className="flex items-start">
                  <span className="w-1 h-1 bg-[#555] rounded-full mt-[7px] mr-3 shrink-0"></span>
                  <span><strong>Random Testing</strong> – Periodic, unannounced drug and alcohol testing will be conducted.</span>
                </li>
                <li className="flex items-start">
                  <span className="w-1 h-1 bg-[#555] rounded-full mt-[7px] mr-3 shrink-0"></span>
                  <span><strong>Post-Accident Testing</strong> – Any driver involved in an accident while operating a company vehicle must undergo immediate drug and alcohol testing.</span>
                </li>
                <li className="flex items-start">
                  <span className="w-1 h-1 bg-[#555] rounded-full mt-[7px] mr-3 shrink-0"></span>
                  <span><strong>Reasonable Suspicion Testing</strong> – If management suspects a driver is under the influence based on behavior, appearance, or other indicators, testing will be required.</span>
                </li>
              </ul>
            </section>

            {/* Section 9 */}
            <section>
              <h4 className="text-[17px] sm:text-[19px] font-bold text-[#191919] mb-3 flex items-start gap-2 mt-8">
                <span className="mt-[6px] w-0 h-0 border-t-[5px] border-t-transparent border-l-[6px] border-l-[#191919] border-b-[5px] border-b-transparent shrink-0"></span>
                <span>5. CONSEQUENCES FOR VIOLATIONS</span>
              </h4>
              <p className="text-[15px] sm:text-[16px] text-[#555] mb-3">
                Any violation of this Zero-Tolerance Policy will result in <strong>immediate disciplinary action</strong>, including but not limited to:
              </p>
              <ul className="list-none space-y-1.5 text-[14px] text-[#555] pl-6 mb-4">
                <li className="flex items-center">
                  <span className="w-1 h-1 bg-[#555] rounded-full mr-3 shrink-0"></span>
                  Immediate suspension from duty.
                </li>
                <li className="flex items-center">
                  <span className="w-1 h-1 bg-[#555] rounded-full mr-3 shrink-0"></span>
                  Termination of employment or contract.
                </li>
                <li className="flex items-center">
                  <span className="w-1 h-1 bg-[#555] rounded-full mr-3 shrink-0"></span>
                  Notification to relevant licensing authorities.
                </li>
                <li className="flex items-center">
                  <span className="w-1 h-1 bg-[#555] rounded-full mr-3 shrink-0"></span>
                  Potential legal action where applicable.
                </li>
              </ul>
            </section>

            {/* Section 10 */}
            <section>
              <h4 className="text-[17px] sm:text-[19px] font-bold text-[#191919] mb-3 flex items-start gap-2 mt-8">
                <span className="mt-[6px] w-0 h-0 border-t-[5px] border-t-transparent border-l-[6px] border-l-[#191919] border-b-[5px] border-b-transparent shrink-0"></span>
                <span>6. REPORTING VIOLATIONS</span>
              </h4>
              <p className="text-[15px] sm:text-[16px] text-[#555] mb-4">
                Passengers, employees, or the public may report suspected violations by calling <strong>(469) 525-3322</strong> or emailing <strong>info@hlselitecars.com</strong>. Reports can be made anonymously.
              </p>
            </section>

            {/* Section 11 */}
            <section>
              <h4 className="text-[17px] sm:text-[19px] font-bold text-[#191919] mb-3 flex items-start gap-2 mt-8">
                <span className="mt-[6px] w-0 h-0 border-t-[5px] border-t-transparent border-l-[6px] border-l-[#191919] border-b-[5px] border-b-transparent shrink-0"></span>
                <span>7. ACKNOWLEDGMENT</span>
              </h4>
              <p className="text-[15px] sm:text-[16px] text-[#555] mb-5">
                All drivers and employees must sign an acknowledgment form confirming they have read, understood, and agreed to comply with this policy. Failure to sign does not exempt any individual from compliance.
              </p>
              
              <hr className="border-[#eee] mb-5" />
              
              <p className="text-[15px] sm:text-[16px] text-[#777] italic mb-10">
                Heartland Limousine Services LLC reserves the right to modify this policy at any time to remain compliant with local, state, and federal regulations.
              </p>
            </section>

            {/* Contact Tags Box */}
            <div className="bg-[#f9f9f9] border border-[#eee] rounded-[4px] p-5 sm:p-6 flex flex-col sm:flex-row flex-wrap items-center justify-between gap-4 sm:gap-6 mt-12">
              <div className="flex items-center gap-2.5 text-[15px] text-[#191919]">
                <User className="w-[18px] h-[18px] text-[#FFCD00]" />
                <span>General Manager : <strong>Ebi S</strong></span>
              </div>

              <div className="hidden sm:block w-[1px] h-6 bg-[#ddd]"></div>

              <div className="flex items-center gap-2.5 text-[15px] text-[#191919]">
                <Phone className="w-[18px] h-[18px] text-[#FFCD00]" />
                <span>Phone : <strong><a href="tel:+14695253322" className="hover:text-[#FFCD00] transition-colors">(469) 525-3322</a></strong></span>
              </div>

              <div className="hidden lg:block w-[1px] h-6 bg-[#ddd]"></div>

              <div className="flex items-center gap-2.5 text-[15px] text-[#191919]">
                <Mail className="w-[18px] h-[18px] text-[#FFCD00]" />
                <span>Email : <strong><a href="mailto:info@hlselitecars.com" className="hover:text-[#FFCD00] transition-colors">info@hlselitecars.com</a></strong></span>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
}
